<app-auth-navbar></app-auth-navbar>
<main class="rtl">
    <div class="relative pt-16 flex content-center items-center justify-center min-h-screen-50">
        <div class="absolute top-0 w-full h-full bg-center bg-cover">
            <span class="bg-primary w-full h-full absolute" id="blackOverlay"></span>
        </div>
        <div class="container relative mx-auto">
            <div class="items-center flex flex-wrap">
                <div class="w-full lg:w-6/12 px-4 ml-auto mr-auto text-center">
                    <div class="">
                        <h1 class="text-white font-semibold text-4xl leading-normal">
                            سامانه ویزیت و مشاوره آنلاین پزشکی
                        </h1>
                        <app-search></app-search>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <section class="py-16 main-bg">
        <div class="container mx-auto px-4">
            <div class="flex flex-wrap">
                <div class="w-full lg:w-6/12 xl:w-8/12 p-4">
                    <div class="bg-white rounded p-4 shadow-lg">
                        <div class="relative md:flex break-words">
                            <img alt="..." [src]="drDetail?.profilePic?apiService.api+drDetail?.profilePic:'../../../assets/img/thumb-profile1.svg.png'"
                                class="shadow-lg rounded-full max-w-120-px max-h-120-px my-4 aspect-square" onerror="this.onerror=null; this.src='../../../assets/img/thumb-profile1.svg.png';"/> 
                            <!-- <img alt="..." src="../../../../assets/img/dr-default-pic.jpg"
                                class="shadow-lg rounded-full max-w-120-px my-4" /> -->
                            <div class="p-4">
                                <h5 class="text-lg font-bold"> {{drDetail?.name}} {{drDetail?.family}} </h5>
                                <p class="mt-1 text-sm text-blueGray-400 uppercase font-semibold">
                                    {{drDetail?.medicalEspertiseName}}
                                </p>
                                <p class="text-sm my-2"> سابقه کار:
                                     {{drDetail?.experience>0?drDetail?.experience:'0'}} 
                                </p>
                                <p class="text-sm my-2"> شماره نظام پزشکی: {{drDetail?.codeNo}} </p>
                                
                                <div class="flex items-center ">
                                    <svg class="w-5 h-5 mx-1 text-yellow-300 me-1" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 22 20">
                                        <path d="M20.924 7.625a1.523 1.523 0 0 0-1.238-1.044l-5.051-.734-2.259-4.577a1.534 1.534 0 0 0-2.752 0L7.365 5.847l-5.051.734A1.535 1.535 0 0 0 1.463 9.2l3.656 3.563-.863 5.031a1.532 1.532 0 0 0 2.226 1.616L11 17.033l4.518 2.375a1.534 1.534 0 0 0 2.226-1.617l-.863-5.03L20.537 9.2a1.523 1.523 0 0 0 .387-1.575Z"/>
                                    </svg>
                                    <p class="me-2 text-sm font-bold text-gray-800 "> {{drDetail?.averageRate}} </p>
                                    <span class="text-sm font-medium text-gray-800 mx-2"> 
                                        ({{drDetail?.comments.length!=0?drDetail?.comments.length:null}} نظر)</span>
                                </div>
                            </div>
                        </div>
                        <hr>
                        <div class="m-2">
                            <p class="text-sm flex">
                                <svg class="w-8 h-8 px-1 text-secondary" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24">
                                    <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M8.5 11.5 11 14l4-4m6 2a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z"/>
                                  </svg>
                                  <span class="mt-1">  نسخه نویسی آنلاین 
                                    <span> {{drDetail?.isActiveAttendanceVisit?'دارد':'ندارد'}} </span>
                                  </span>
                            </p>
                        </div>

                        <div class="m-2">
                            <p class="text-sm flex">
                                <svg class="w-8 h-8 px-1 text-secondary" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24">
                                    <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M8.5 11.5 11 14l4-4m6 2a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z"/>
                                  </svg>
                                  <span class="mt-1">  تسلط به زبان (جهت ویزیت کردن):  </span>
                                  <span *ngFor="let lang of drDetail?.lags" class="text-primary text-xs font-medium inline-block p-1 px-2 rounded border border-primary m-1"> {{lang}} </span>
                            </p>
                            <!-- <p>
                                
                            </p> -->
                        </div>

                        <div class="m-2">
                            <p class="text-sm flex">
                                <svg class="w-8 h-8 px-1 text-secondary" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24">
                                    <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M8.5 11.5 11 14l4-4m6 2a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z"/>
                                  </svg>
                                  <span class="mt-1">  کلمات کلیدی: </span>
                                  <span *ngFor="let tag of drDetail?.tags" class="text-primary text-xs font-medium inline-block p-1 px-2 rounded border border-primary m-1"> {{tag}} </span>

                            </p>
                            <!-- <p>
                            </p> -->
                        </div>

                        <hr>
                        <div class="mt-4">
                            <p class="text-base flex">
                                <svg class="w-8 h-8 px-1 text-secondary" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24">
                                    <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M8.5 11.5 11 14l4-4m6 2a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z"/>
                                  </svg>
                                  <span class="mt-1">  خدمات: </span>
                                </p>
                        </div>

                        <div class="md:flex mt-2 mb-8">
                            <ng-container *ngFor="let vType of drDetail?.visitType">
                                <p *ngIf="visitType.VideoVisit==vType" class="text-sm flex p-2"> <img src="../../../../assets/img/icon/video-call.svg" alt=""
                                        width="20px"> <span> ویزیت تصویری </span></p>
                                <p *ngIf="visitType.PhoneVisit==vType" class="text-sm flex p-2"> <img src="../../../../assets/img/icon/voice-call.svg" alt=""
                                        width="16px"> ویزیت صوتی </p>
                                <p *ngIf="visitType.TextVisit==vType" class="text-sm flex p-2"> <img src="../../../../assets/img/icon/message.svg" alt=""
                                        width="20px"> مشاوره متنی </p>
                                <p *ngIf="visitType.BodyVisit==vType" class="text-sm flex p-2"> <img src="../../../../assets/img/icon/hospital.svg" alt=""
                                        width="16px"> ویزیت حضوری </p>
                            </ng-container>        
                        </div>
                    </div>
                </div>
                <div class="w-full lg:w-6/12 xl:w-4/12 p-4">
                    <div *ngIf="visitTypeAndPrice" class="bg-white rounded p-4 mb-6 xl:mb-0 shadow-lg">
                        <ul class="w-full">
                            <!-- <div *ngIf="visitTypeAndPrice.videoVisit!=null&&visitTypeAndPrice.voiceVisit!=null&&visitTypeAndPrice.textVisit!=null&&visitTypeAndPrice.visit!=null">
                            <li *ngIf="visitTypeAndPrice.videoVisit?.start==0&&visitTypeAndPrice.voiceVisit?.start==0&&visitTypeAndPrice.textVisit?.start==0&&visitTypeAndPrice.visit?.start==0" class="w-full">
                                <input type="radio" id="hosting-video" name="hosting" 
                                    class="visit-type text-primary hidden" disabled />
                                <label for="hosting-video"
                                    class="w-full grid p-5 text-gray-500 bg-gray-100 rounded-lg cursor-pointer hover:text-gray-600 hover:bg-gray-100">
                                    <p class="text-red-600"> برای این پزشک و این روز نوبتی وجود ندارد </p>
                                </label>
                            </li>
                            </div> -->
                            <li class="w-full">
                                <input type="radio" id="hosting-video" name="hosting" [value]="visitType.VideoVisit" [disabled]="visitTypeAndPrice.videoVisit==null?true:false"
                                    class="visit-type text-secondary" [checked]="isVideo" (change)="addVisit.visitType=visitType.VideoVisit;generateTimeList(visitTypeAndPrice.videoVisit?.start, visitTypeAndPrice.videoVisit.end, visitTypeAndPrice.videoVisit?.duration)" />
                                <label for="hosting-video"
                                    class="w-full grid p-5 text-gray-500 bg-gray-100 rounded-lg cursor-pointer hover:text-gray-600 hover:bg-gray-100 ">
                                    <div class="inline-flex items-center justify-between ">
                                        <div class="flex text-lg font-semibold"> <img
                                                src="../../../../assets/img/icon/video-call.svg" alt="" class="ml-2"
                                                width="20px"> <span> ویزیت تصویری </span> </div>

                                        <span class="bg-gray-200 py-1 px-2 rounded-lg text-sm"> {{visitTypeAndPrice.videoVisit?.price| number:''}} تومان </span>
                                    </div>
                                    <div class="block">
                                        <div class="w-full mt-3 pr-6"> {{visitTypeAndPrice.videoVisit?.duration}} دقیقه مکالمه تصویری + چت با پزشک </div>
                                    </div>
                                </label>
                            </li>
                            <li class="w-full">
                                <input type="radio" id="hosting-call" name="hosting" [value]="visitType.PhoneVisit" [disabled]="visitTypeAndPrice.voiceVisit==null?true:false"
                                    class="visit-type text-secondary" (change)="isVideo=false;addVisit.visitType=visitType.PhoneVisit;generateTimeList(visitTypeAndPrice.voiceVisit?.start, visitTypeAndPrice.voiceVisit.end, visitTypeAndPrice.voiceVisit?.duration)" />
                                <label for="hosting-call"
                                    class="w-full grid p-5 text-gray-500 bg-gray-100 rounded-lg cursor-pointer hover:text-gray-600 hover:bg-gray-100 ">
                                    <div class="inline-flex items-center justify-between ">
                                        <div class="flex text-lg font-semibold"> <img
                                                src="../../../../assets/img/icon/voice-call.svg" alt="" class="ml-2"
                                                width="16px"> <span> ویزیت صوتی </span> </div>

                                        <span class="bg-gray-200 py-1 px-2 rounded-lg text-sm"> {{visitTypeAndPrice.voiceVisit?.price| number:''}} تومان </span>
                                    </div>
                                    <div class="block">
                                        <div class="w-full mt-3 pr-6"> {{visitTypeAndPrice.voiceVisit?.duration}} دقیقه مکالمه صوتی + چت با پزشک </div>
                                    </div>
                                </label>
                            </li>
                            <li class="w-full">
                                <input type="radio" id="hosting-chat" name="hosting" [value]="visitType.TextVisit" [disabled]="visitTypeAndPrice.textVisit==null?true:false"
                                    class="visit-type text-primary" (change)="isVideo=false;addVisit.visitType=visitType.TextVisit;generateTimeList(0,0,0)" />
                                <label for="hosting-chat"
                                    class="w-full grid p-5 text-gray-500 bg-gray-100 rounded-lg cursor-pointer hover:text-gray-600 hover:bg-gray-100 ">
                                    <div class="inline-flex items-center justify-between ">
                                        <div class="flex text-lg font-semibold"> <img
                                                src="../../../../assets/img/icon/message.svg" alt="" class="ml-2"
                                                width="20px"> <span> مشاوره متنی </span> </div>

                                        <span class="bg-gray-200 py-1 px-2 rounded-lg text-sm"> {{visitTypeAndPrice.textVisit?.price| number:''}} تومان </span>
                                    </div>
                                    <div class="block">
                                        <div class="w-full mt-3 pr-6"> گفتگوی متنی با پزشک </div>
                                    </div>
                                </label>
                            </li>
                            <li class="w-full">
                                <input type="radio" id="hosting-meeting" name="hosting" [value]="visitType.BodyVisit" [disabled]="visitTypeAndPrice.visit==null?true:false"
                                    class="visit-type text-secondary disabled:cursor-not-allowed" (change)="isVideo=false;addVisit.visitType=visitType.BodyVisit;generateTimeList(visitTypeAndPrice.visit?.start, visitTypeAndPrice.visit.end, visitTypeAndPrice.visit?.duration)" />
                                <label for="hosting-meeting"
                                    class="w-full grid p-5 text-gray-500 bg-gray-100 rounded-lg cursor-pointer hover:text-gray-600 hover:bg-gray-100">
                                    <div class="inline-flex items-center justify-between ">
                                        <div class="flex text-lg font-semibold"> <img
                                                src="../../../../assets/img/icon/hospital.svg" alt="" class="ml-2"
                                                width="16px"> <span> ویزیت حضوری </span> </div>

                                        <span class="bg-gray-200 py-1 px-2 rounded-lg text-sm"> {{visitTypeAndPrice.visit?.price| number:''}} تومان </span>
                                    </div>
                                    <div class="block">
                                        <div class="w-full mt-3 pr-6"> {{visitTypeAndPrice.visit?.duration}} دقیقه ملاقات حضوری با پزشک </div>
                                    </div>
                                </label>
                            </li>
                        </ul>
                        <div class="mt-6 flex justify-end">
                            <button class=" text-white font-bold w-full rounded-lg py-3 mb-1" type="button" style="background-color: #0080D0;"
                                (click)="takeVisit()"> دریافت نوبت
                            </button>
                        </div>
                    </div>
                </div>
            </div>
            <div class="flex flex-wrap">
                <div class="w-full lg:w-6/12 xl:w-8/12 p-4 relative md:-top-170-px">

                    <div class="bg-white rounded mb-6 shadow-lg">
                        <!-- <div class="relative flex break-words bg-primary-light p-3">
                            <h5 class="font-bold text-primary"> تاریخ </h5>
                        </div> -->

                        <div class="carousel-section">
                            <div class="carousel-container bg-gray-100 p-10">

                                <div class="carousel-wrapper flex"
                                    [style.transform]="'translateX(+' + currentIndex * 100 + '%)'">
                                    <div class="carousel-slide w-2/12" *ngFor="let slide of calendar;let f=first;">
                                        <input type="radio" [id]="'day'+slide.date" name="date" value="" [checked]="f"
                                            class="date-select hidden" (change)="timeList=[];getVisitsList(slide.dayEnum);selectedDate=slide.gregorianDateTime;getTakenVisited()"/>
                                        <label [for]="'day'+slide.date" 
                                            class="card rounded bg-white text-center transition-all duration-300 hover:shadow-md">
                                            <div class="card-body p-4">
                                                <h4 class="text-base font-bold">{{ slide.day }}</h4>
                                                <p class="mt-2 text-sm">{{ slide.date }} </p>
                                            </div>
                                        </label>
                                    </div>
                                </div>

                                <!-- carousel control -->
                                <div class="carousel-header">
                                    <div class="carousel-controls">
                                        <button (click)="updateCarousel(1)" [disabled]="currentIndex==totalPages-1"
                                            class="carousel-btn cursor-pointer rounded-full bg-white shadow disabled:bg-transparent disabled:cursor-auto">
                                            <img src="../../../assets/img/icon/keyboard_arrow_left.svg" alt="">
                                        </button>
                                        <button (click)="updateCarousel(-1)" [disabled]="currentIndex==0"
                                            class="carousel-btn cursor-pointer rounded-full bg-white shadow disabled:bg-transparent disabled:cursor-auto">
                                            <img src="../../../assets/img/icon/keyboard_arrow_right.svg" alt="">
                                        </button>
                                    </div>
                                </div>

                            </div>
                            <hr>
                            <div class="flex flex-wrap py-4 px-12">
                                <!-- <div *ngFor="let hour of timeList" class="w-auto my-4">
                                        <input type="radio" [id]="'h'+hour" name="hour" value=""
                                            class="hour-select hidden" [disabled]="" />
                                        <label [for]="'h'+hour" 
                                            class="rounded py-1 px-3 m-2 text-base bg-primary-light transition-all duration-300 hover:cursor-pointer hover:shadow-md">
                                                {{hour}}
                                        </label>
                                      
                                </div> -->
                                <ng-container *ngIf="timeList.length==0 && addVisit.visitType!=visitType.TextVisit || isExceptedDate()">
                                    <p class="text-red-600"> در این تاریخ نوبت خالی موجود نمی باشد </p>
                                </ng-container>
                                <ng-container *ngIf="timeList.length!=0 && !isExceptedDate()" >
                                <div *ngFor="let hour of timeList" class="w-auto ">
                                    <input 
                                        type="radio" 
                                        [id]="'h'+hour" 
                                        name="hour" 
                                        [value]="hour" 
                                        class="hour-select hidden disabled:cursor-not-allowed" 
                                        [disabled]="isDisabled(hour)" 
                                        (change)="onTimeSelect(hour)"
                                    />
                                    <label 
                                        [for]="'h'+hour" 
                                        class="rounded py-1 px-3 m-2 text-base bg-primary-light transition-all duration-300 hover:cursor-pointer hover:shadow-md disabled:cursor-not-allowed grid w-16"
                                        [class.bg-red-200]="isDisabled(hour)" 
                                        [class.cursor-not-allowed]="isDisabled(hour)"
                                        [class.text-gray-500]="isDisabled(hour)">
                                        {{hour}}
                                    </label>
                                </div>
                                </ng-container>
                            </div>
                        </div>
                    </div>

                    <div class="bg-white rounded mb-6 shadow-lg">
                        <div class="relative flex break-words bg-primary-light p-3">
                            <h5 class="font-bold text-primary"> درباره پزشک </h5>
                        </div>
                        <div class="p-3">
                            <p class="text-base"> {{drDetail?.aboutMe}} </p>
                            <br><br>
                        </div>
                    </div>

                    <div class="bg-white rounded mb-6 shadow-lg">
                        <div class="relative flex break-words bg-primary-light p-3">
                            <h5 class="font-bold text-primary"> اطلاعات مطب </h5>

                        </div>
                        <div class="p-3">
                            <p class="text-base"> آدرس: {{drDetail?.workAddress}} </p>
                            <br>
                            <p class="text-base"> تجهیزات: {{drDetail?.officeEquipment}} </p>
                            <br><br>
                        </div>
                    </div>

                    <div class="bg-white rounded mb-6 shadow-lg">
                        <div class="relative flex break-words bg-primary-light p-3">
                            <h5 class="font-bold text-primary"> نظرسنجی و امتیاز دهی </h5>

                        </div>
                        <div *ngFor="let comment of drDetail?.comments" class="p-5 pb-0">
                            <article>
                                <div class="flex items-center mb-4">
                                    <span class="w-8 h-8 me-4 rounded-full" > <svg class="w-8 h-8 text-gray-800 " aria-hidden="true" xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24">
                                        <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 21a9 9 0 1 0 0-18 9 9 0 0 0 0 18Zm0 0a8.949 8.949 0 0 0 4.951-1.488A3.987 3.987 0 0 0 13 16h-2a3.987 3.987 0 0 0-3.951 3.512A8.948 8.948 0 0 0 12 21Zm3-11a3 3 0 1 1-6 0 3 3 0 0 1 6 0Z"/>
                                      </svg>
                                     </span>
                                    <div class="font-medium ">
                                        <p> {{comment.userName}} <span class="block text-sm text-gray-500"> {{comment.date|shamsiDate}} </span></p>
                                    </div>
                                </div>
                                
                                <p class="mb-2 text-gray-500"> {{comment.comment}} </p>
                                
                            </article>
                            <hr>
                        </div>
                    </div>
                </div>

                <div class="w-full lg:w-6/12 xl:w-4/12 p-4">
                    <!-- <div class="bg-white rounded p-4 mb-6 xl:mb-0 shadow-lg">
                        <ul class="w-full">
                            <li *ngIf="visitTypeAndPrice.videoVisit!=null" class="w-full">
                                <input type="radio" id="hosting-video" name="hosting" value=""
                                    class="visit-type text-primary" checked />
                                <label for="hosting-video"
                                    class="w-full grid p-5 text-gray-500 bg-gray-100 rounded-lg cursor-pointer hover:text-gray-600 hover:bg-gray-100">
                                    <div class="inline-flex items-center justify-between ">
                                        <div class="flex text-lg font-semibold"> <img
                                                src="../../../../assets/img/icon/video-call.svg" alt="" class="ml-2"
                                                width="20px"> <span> مشاوره تصویری </span> </div>

                                        <span class="bg-gray-200 py-1 px-2 rounded-lg text-sm"> {{visitTypeAndPrice.videoVisit?.price}} تومان </span>
                                    </div>
                                    <div class="block">
                                        <div class="w-full mt-3 pr-6"> {{visitTypeAndPrice.videoVisit?.duration}} دقیقه مکالمه تصویری + چت با پزشک </div>
                                    </div>
                                </label>
                            </li>
                            <li *ngIf="visitTypeAndPrice.voiceVisit!=null" class="w-full">
                                <input type="radio" id="hosting-call" name="hosting" value=""
                                    class="visit-type text-primary" />
                                <label for="hosting-call"
                                    class="w-full grid p-5 text-gray-500 bg-gray-100 rounded-lg cursor-pointer hover:text-gray-600 hover:bg-gray-100">
                                    <div class="inline-flex items-center justify-between ">
                                        <div class="flex text-lg font-semibold"> <img
                                                src="../../../../assets/img/icon/voice-call.svg" alt="" class="ml-2"
                                                width="16px"> <span> مشاوره تلفنی </span> </div>

                                        <span class="bg-gray-200 py-1 px-2 rounded-lg text-sm"> {{visitTypeAndPrice.voiceVisit?.price}} تومان </span>
                                    </div>
                                    <div class="block">
                                        <div class="w-full mt-3 pr-6"> {{visitTypeAndPrice.voiceVisit?.duration}} دقیقه مکالمه تلفنی + چت با پزشک </div>
                                    </div>
                                </label>
                            </li>
                            <li *ngIf="visitTypeAndPrice.textVisit!=null" class="w-full">
                                <input type="radio" id="hosting-chat" name="hosting" value=""
                                    class="visit-type text-primary" />
                                <label for="hosting-chat"
                                    class="w-full grid p-5 text-gray-500 bg-gray-100 rounded-lg cursor-pointer hover:text-gray-600 hover:bg-gray-100">
                                    <div class="inline-flex items-center justify-between ">
                                        <div class="flex text-lg font-semibold"> <img
                                                src="../../../../assets/img/icon/message.svg" alt="" class="ml-2"
                                                width="20px"> <span> مشاوره متنی </span> </div>

                                        <span class="bg-gray-200 py-1 px-2 rounded-lg text-sm"> {{visitTypeAndPrice.textVisit?.price}} تومان </span>
                                    </div>
                                    <div class="block">
                                        <div class="w-full mt-3 pr-6"> {{visitTypeAndPrice.textVisit?.duration}} دقیقه چت با پزشک </div>
                                    </div>
                                </label>
                            </li>
                            <li *ngIf="visitTypeAndPrice.visit!=null" class="w-full">
                                <input type="radio" id="hosting-meeting" name="hosting" value=""
                                    class="visit-type text-primary" />
                                <label for="hosting-meeting"
                                    class="w-full grid p-5 text-gray-500 bg-gray-100 rounded-lg cursor-pointer hover:text-gray-600 hover:bg-gray-100">
                                    <div class="inline-flex items-center justify-between ">
                                        <div class="flex text-lg font-semibold"> <img
                                                src="../../../../assets/img/icon/hospital.svg" alt="" class="ml-2"
                                                width="16px"> <span> مشاوره حضوری </span> </div>

                                        <span class="bg-gray-200 py-1 px-2 rounded-lg text-sm"> {{visitTypeAndPrice.visit?.price}} تومان </span>
                                    </div>
                                    <div class="block">
                                        <div class="w-full mt-3 pr-6"> {{visitTypeAndPrice.visit?.duration}} دقیقه </div>
                                    </div>
                                </label>
                            </li>
                        </ul>
                        <div class="mt-6 flex justify-end">
                            <button class="bg-primary text-white font-bold w-full rounded-lg py-3 mb-1" type="button"
                                (click)="takeVisit();"> دریافت نوبت
                            </button>
                        </div>
                    </div> -->
                </div>

            </div>
        </div>
    </section>


</main>
<app-footer></app-footer>

<p-toast dir="rtl"></p-toast>


<app-modal #modal>
    <!--header-->
    <div class="flex items-start justify-between p-2 border-b border-solid border-blueGray-200 rounded-t">
      <h3 class="text-2xl font-semibold">
        ورود به سایت
      </h3>
      <button
        class="p-1 bg-transparent border-0 text-black opacity-5 float-right text-3xl leading-none font-semibold outline-none focus:outline-none"
        (click)="modal.close()">
        <span class="bg-transparent text-black opacity-5 h-6 w-6 text-2xl block outline-none focus:outline-none">
          ×
        </span>
      </button>
    </div>
    <!--body-->
    <div class="relative p-4 flex-auto">
        <p class="mt-4 mb-12 text-blueGray-500 text-lg text-start leading-relaxed">
            برای استفاده از تمام امکانات استاد ویزیت لازم است وارد شوید، برای ورود از طریق لینک زیر اقدام کنید.
        </p>
      </div>
    <!--footer-->
    <div class="flex items-center justify-between py-2 border-solid border-blueGray-200 rounded-b">
      <button
        class="text-red-500 border-red-500 background-transparent font-bold px-6 py-2 rounded text-sm my-2 ease-linear transition-all duration-150"
        type="button" (click)="modal.close()">
        انصراف
      </button>
      <button
        class="bg-primary text-white active:bg-red-500 font-bold text-sm px-6 py-2 rounded shadow hover:shadow-lg my-2 ease-linear transition-all duration-150"
        type="button" (click)="login()">
        ورود
      </button>
    </div>
  </app-modal>